import React, { PureComponent } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Image } from "semantic-ui-react";
import { getLabel } from "../../constants/Strings";
import { navigate } from "../../redux/actions/navigation";
import { login } from "../../redux/actions/user";
import PasswordInput from "../../components/PasswordInput/PasswordInput";
import Input from "../../components/Input/Input";

class LoginScreen extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      phone: "",
      password: "",
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSignIn = async () => {
    const { phone, password } = this.state;
    await this.props.dispatch(login(phone, password));
  };

  handleSignUp = (e) => {
    e.preventDefault();
    this.props.dispatch(navigate("/sign-up"));
  };

  handleForgotPassword = (e) => {
    e.preventDefault();
    this.props.dispatch(navigate("/forgot-password"));
  };

  render() {
    const { phone, password } = this.state;
    const { navigation } = this.props;

    if (navigation.navigate && window.location.pathname !== navigation.route) {
      return <Redirect push to={navigation.route} />;
    }

    const styles = {
      globalContainer: {
        background: 'linear-gradient(135deg, #1a1a1a 0%, #ce1d1a 100%)',
        backgroundImage: 'url("/background.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        padding: '20px',
      },
      logoContainer: {
        marginBottom: '40px',
        textAlign: 'center',
      },
      logo: {
        width: '200px',
        height: 'auto',
        filter: 'drop-shadow(0 4px 10px rgba(0, 0, 0, 0.3))',
      },
      loginCard: {
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(15px)',
        WebkitBackdropFilter: 'blur(15px)',
        padding: '40px 30px',
        borderRadius: '24px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.3)',
        width: '100%',
        maxWidth: '400px',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      },
      forgotPasswordLink: {
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: '0.9rem',
        textAlign: 'right',
        cursor: 'pointer',
        marginTop: '-10px',
        transition: 'color 0.3s ease',
      },
      signInButton: {
        background: 'linear-gradient(135deg, #ce1d1a 0%, #b01815 100%)',
        color: 'white',
        borderRadius: '12px',
        padding: '16px',
        fontWeight: '700',
        fontSize: '1.1rem',
        border: 'none',
        boxShadow: '0 4px 15px rgba(206, 29, 26, 0.4)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        textTransform: 'uppercase',
        letterSpacing: '1px',
      },
      signUpButton: {
        background: 'transparent',
        color: 'white',
        borderRadius: '12px',
        padding: '14px',
        fontWeight: '600',
        fontSize: '1rem',
        border: '2px solid rgba(255, 255, 255, 0.3)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        textTransform: 'uppercase',
      },
      divider: {
        display: 'flex',
        alignItems: 'center',
        color: 'rgba(255, 255, 255, 0.5)',
        fontSize: '0.8rem',
        margin: '10px 0',
      },
      dividerLine: {
        flex: 1,
        height: '1px',
        background: 'rgba(255, 255, 255, 0.2)',
        margin: '0 10px',
      }
    };

    return (
      <div style={styles.globalContainer} className="dark-bg">
        <div style={styles.logoContainer}>
          <Image src="/logo3_1.png" style={styles.logo} />
        </div>

        <div style={styles.loginCard}>
          <Input
            value={phone}
            name="phone"
            placeholder={getLabel("Phone")}
            onChange={this.handleInputChange}
            type="text"
            icon="phone"
          />
          <PasswordInput
            value={password}
            name="password"
            placeholder={getLabel("Password")}
            onChange={this.handleInputChange}
            icon="lock"
          />

          <div
            style={styles.forgotPasswordLink}
            onClick={this.handleForgotPassword}
            onMouseOver={(e) => e.target.style.color = '#ffffff'}
            onMouseOut={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
          >
            {getLabel("ForgotYourPassword")}
          </div>

          <button
            style={styles.signInButton}
            onClick={this.handleSignIn}
            onMouseOver={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 8px 25px rgba(206, 29, 26, 0.6)';
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 15px rgba(206, 29, 26, 0.4)';
            }}
          >
            {getLabel("SignIn")}
          </button>

          <div style={styles.divider}>
            <div style={styles.dividerLine} />
            {getLabel("OR")}
            <div style={styles.dividerLine} />
          </div>

          <button
            style={styles.signUpButton}
            onClick={this.handleSignUp}
            onMouseOver={(e) => {
              e.target.style.background = 'rgba(255, 255, 255, 0.1)';
              e.target.style.borderColor = 'rgba(255, 255, 255, 0.8)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
            }}
          >
            {getLabel("SignUp")}
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ navigation }) => ({ navigation });

export default connect(mapStateToProps)(LoginScreen);
